import { MOBILE_VIEW_LIQUIDITY_OPTIONS } from '@paradigm/features/src/leaderboard/entities/shared';
import BaseMenuSelect from '#/components/Leaderboard/shared/BaseMenuSelect';

export default function LiquidityMobileMenuSection({
  onChange,
  value,
}: {
  onChange: (tab: string) => void;
  value: string;
}) {
  return (
    <BaseMenuSelect
      value={value}
      onChange={(tab) => onChange(tab)}
      options={MOBILE_VIEW_LIQUIDITY_OPTIONS}
    />
  );
}
